import { GenericModel } from "../../../generic.model";
import { makeModel } from "../../../../service/utils/utils.service";
import { GenericTotalModel } from "../total/genericTotal.model";


export class DetailModel extends GenericModel {
    public baseArray: GenericTotalModel[];
    public feeArray: GenericTotalModel[];
    public supplementArray: GenericTotalModel[];
    // TODO rate: {keywordArray: [{xCode: "UnlimitedDistance", afid: "KW_UnlimitedDistance", index: 1}],…}
    // TODO productArray: [{xRef: "SP.10"}]
    // TODO travellerArray: [{xRef: "T.1"}]
    // TODO vehicleArray: [{xRef: "VH.16"}]
    // TODO vehicleRentalArray: [{xRef: "SVH.1"}]


    protected fromJson(json?: any): boolean {
        this.baseArray = makeModel(json.baseArray, GenericTotalModel);
        this.feeArray = makeModel(json.feeArray, GenericTotalModel);
        this.supplementArray = makeModel(json.supplementArray, GenericTotalModel);
        return this.isValid();
    }

    protected isValid(): boolean {
        return true;
    }
}